import React from "react";
import TriviasContainer from "./TriviasContainer";

const Trivias = (props) => {
  return (
      <TriviasContainer {...props} />
  );
};

export default Trivias;
